import store from '@/pages/subject/classRoom/store';

// 广告位(/common/brandLineAndImageList)走独立站点的 project
export const ACTIVITY_SITE_PROJECT = '5';
// 活动列表(/uc/showActivityInfoList)走独立站点的 showType
export const ACTIVITY_SITE_SHOW_TYPE = '7';

// 类型值比较，接口可能给数字也可能给字符串
export function isSameType(type, target) {
  return String(type === undefined || type === null ? '' : type) === String(target);
}

// 路径补全：不以 /# 开头时补 /#
export function normalizeActivityPath(path) {
  if (!path) { return '' }
  let result = String(path).trim();
  if (!result) { return '' }
  if (result.indexOf('/#') === 0) { return result }
  if (result.indexOf('#/') === 0) { return '/' + result }
  if (result.charAt(0) !== '/') { result = '/' + result }
  return '/#' + result;
}

// 可访问域名 + 路径，取不到域名返回 ''
export async function getActivitySiteUrl(path) {
  const activityPath = normalizeActivityPath(path);
  if (!activityPath) { return '' }
  const domain = await store.dispatch('serverConfig/getActivityDomain');
  if (!domain) { return '' }
  return String(domain).replace(/\/+$/, '') + activityPath;
}

// 广告位：命中独立站点 → 活动站点地址，否则 → item.url
export async function getBannerJumpUrl(item) {
  if (!item) { return '' }
  if (isSameType(item.project, ACTIVITY_SITE_PROJECT)) {
    const url = await getActivitySiteUrl(item.path);
    if (url) { return url }
  }
  return item.url || '';
}

// 活动列表：命中独立站点 → 活动站点地址，否则 → item.showInfo
export async function getActivityJumpUrl(item) {
  if (!item) { return '' }
  if (isSameType(item.showType, ACTIVITY_SITE_SHOW_TYPE)) {
    const url = await getActivitySiteUrl(item.showInfo);
    if (url) { return url }
  }
  return item.showInfo || '';
}

// 广告位数据加载完成后可调用，提前探测域名，避免点击时等待
export function preloadActivityDomain() {
  return store.dispatch('serverConfig/getActivityDomain');
}
